"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POLYGON_TICKERS = void 0;
const polygon_token_1 = require("./polygon-token");
const ticker_1 = require("./ticker");
exports.POLYGON_TICKERS = [ticker_1.Ticker.MATIC, ...polygon_token_1.POLYGON_TOKEN_TICKERS];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9seWdvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90aWNrZXJzL3BvbHlnb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQ0EsbURBQXVEO0FBRXZELHFDQUFpQztBQUVwQixRQUFBLGVBQWUsR0FBRyxDQUFDLGVBQU0sQ0FBQyxLQUFLLEVBQUUsR0FBRyxxQ0FBcUIsQ0FBQyxDQUFBIn0=